import React from "react";
import PaginationModified from "../../../../data/PaginationModified";
import {
  convertThenFormat,
  formatDateTimezon,
} from "../../../common-data/Converts";

const TrainerIncentivesMobile = ({
  tableData,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  onClickAddBtn,
}) => {
  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="all-leads-log">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="all-followuo-info-container">
                  <div
                    className="lead-multi-value-cols"
                    style={{
                      padding: "20px",
                    }}
                  >
                    <div className="label-value">
                      <span className="label">monthly salary</span>
                      <span className="value">
                        ₹{convertThenFormat(row?.monthly_salary || 0)}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">total incentives</span>
                      <span className="value">
                        ₹{convertThenFormat(row?.total_incentive || 0)}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">total earned</span>
                      <span className="value">
                        ₹{convertThenFormat(row?.total_earned_salary || 0)}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">applicable subscriptions</span>
                      <span
                        className={`value  ${
                          Number(row?.applicable_sub_count || 0) ? "link" : ""
                        }`}
                        onClick={() =>
                          Number(row?.applicable_sub_count || 0) &&
                          onClickAddBtn("applicable-subscriptions", row)
                        }
                      >
                        {row?.applicable_sub_count || 0}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">Next incentive date</span>
                      <span className="value ">
                        {row?.next_incentive_date
                          ? formatDateTimezon(row.next_incentive_date)
                          : "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

      <div className="lead-logs-card-pagination">
        <PaginationModified
          isPage={isPage}
          onChangePage={setIsPage}
          pagination={getPagination()}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      </div>
    </div>
  );
};

export default TrainerIncentivesMobile;
